import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-09-21
 * @brief SIE 솔루션 관리 개발
 *
 ********************************************************************/
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import SolutionCard from "./SolutionCard";
import SolutionGroups from "./SolutionGroups";
export default function SolutionMaIn() {
    //props
    const { handleOpenPop } = useOutletContext();
    // tree 선택 시 이동
    const [selTree, setSelTree] = useState("GROUP"); //CARD
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx("div", Object.assign({ className: "box treebar pushy-menutype type3" }, { children: _jsx("div", Object.assign({ className: "lnb" }, { children: _jsxs("ul", Object.assign({ className: "lnb-depth1" }, { children: [_jsx("li", Object.assign({ className: selTree == "GROUP" ? "active" : "", onClick: (e) => setSelTree("GROUP") }, { children: _jsx("p", { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: "\uC194\uB8E8\uC158 \uADF8\uB8F9 \uAD00\uB9AC" }) })) }) })), _jsx("li", Object.assign({ className: selTree == "CARD" ? "active" : "", onClick: (e) => setSelTree("CARD") }, { children: _jsx("p", { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault() }, { children: _jsx("span", { children: "\uC194\uB8E8\uC158 \uCE74\uB4DC \uAD00\uB9AC" }) })) }) }))] })) })) })), selTree == "GROUP" && _jsx(SolutionGroups, { handleOpenPop: handleOpenPop }), selTree == "CARD" && _jsx(SolutionCard, { handleOpenPop: handleOpenPop })] })) }));
}
